export const EventKey = {
    Escape: 'Escape',
    Enter: 'Enter',
    ArrowUp: 'ArrowUp',
    ArrowDown: 'ArrowDown',
    Home: 'Home',
    End: 'End',
    Tab: 'Tab',
    A: 'a',
    Space: ' ',
};
